"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arcola": {
    "e25ad7f2": [{
      "hkey": "fe7f9263",
      "slug": "baccano-pietralba",
      "name": "Baccano-Pietralba",
      "primary": true,
      "skipSearch": false
    }],
    "baccano": [{
      "hkey": "fe7f9263",
      "slug": "baccano-pietralba",
      "name": "Baccano-Pietralba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2108692d": [{
      "hkey": "fc03bb5b",
      "slug": "fresonara-monti",
      "name": "Fresonara-Monti",
      "primary": true,
      "skipSearch": false
    }],
    "fresonara": [{
      "hkey": "fc03bb5b",
      "slug": "fresonara-monti",
      "name": "Fresonara-Monti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dd28e92f": [{
      "hkey": "fc03bb5b",
      "slug": "fresonara-monti",
      "name": "Fresonara-Monti",
      "primary": true,
      "skipSearch": false
    }],
    "monti": [{
      "hkey": "fc03bb5b",
      "slug": "fresonara-monti",
      "name": "Fresonara-Monti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "12654424": [{
      "hkey": "84b386d2",
      "slug": "ponte-di-arcola-piano-di-arcola",
      "name": "Ponte di Arcola-Piano di Arcola",
      "primary": true,
      "skipSearch": false
    }],
    "piano-di-arcola": [{
      "hkey": "84b386d2",
      "slug": "ponte-di-arcola-piano-di-arcola",
      "name": "Ponte di Arcola-Piano di Arcola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b2a0c043": [{
      "hkey": "84b386d2",
      "slug": "ponte-di-arcola-piano-di-arcola",
      "name": "Ponte di Arcola-Piano di Arcola",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-di-arcola": [{
      "hkey": "84b386d2",
      "slug": "ponte-di-arcola-piano-di-arcola",
      "name": "Ponte di Arcola-Piano di Arcola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;